import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { CommonModule } from "@angular/common";
import { TwoFactorAuthService } from "@app/shared/auth/services/two-factor-auth.service";

@Component({
  selector: "app-auth-layout",
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: "./auth-layout.component.html",
  styleUrls: ["./auth-layout.component.scss"],
  providers: [TwoFactorAuthService],
})
export class AuthLayoutComponent {
  // This is a simple layout component for authentication pages
}
